import { EmployeePaymentMethodType } from '@zorro/clients';
import { Divider } from '@zorro/design-system/v2/Divider';
import { formatCurrencyEnUs } from '@zorro/shared/formatters';
import { Group, Stack, Text } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';

type Props = {
  employeeId: string;
  onboardingPeriodId: string;
};

export const PaymentAmountDistribution = ({
  employeeId,
  onboardingPeriodId,
}: Props) => {
  const { data, isLoading } = useMonolithQuery({
    method: 'paymentsControllerEmployeePaymentMethodDetails',
    params: [employeeId, { onboardingPeriodId }],
  });

  if (isLoading || !data || data.type !== EmployeePaymentMethodType.COMBINED) {
    return null;
  }

  const zorroPayText =
    data?.associatedBenefits?.majorMedical.premiumAmount &&
    data?.associatedBenefits?.majorMedical.selfPayAmount
      ? formatCurrencyEnUs(
          data.associatedBenefits.majorMedical.premiumAmount -
            data.associatedBenefits.majorMedical.selfPayAmount
        )
      : 'N/A';
  const selfPayText = data?.associatedBenefits?.majorMedical.selfPayAmount
    ? formatCurrencyEnUs(data.associatedBenefits.majorMedical.selfPayAmount)
    : 'N/A';

  return (
    <Stack gap="xs">
      <Text fw={600} size="sm">
        Payment amount distribution
      </Text>
      <Group gap="lg">
        <Group gap="xs">
          <Text size="sm" c="var(--color-text-default-secondary)">
            Zorro Pay:
          </Text>
          <Text size="sm" fw={600}>
            {zorroPayText}
          </Text>
        </Group>
        <Group gap="xs">
          <Text size="sm" c="var(--color-text-default-secondary)">
            Self-pay:
          </Text>
          <Text size="sm" fw={600}>
            {selfPayText}
          </Text>
        </Group>
      </Group>
      <Divider />
    </Stack>
  );
};
